var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"id":"inspire"}},[_c('Navbar',{attrs:{"show-nav-demand":true,"show-nav-store":true}}),_c('v-main',{staticClass:"contents"},[_c('RouterView')],1),_c('Footer'),_c('Modal'),_c('Loader')],1)}
var staticRenderFns = []

export { render, staticRenderFns }